import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIcon)?_c('span',{staticClass:"workspaceIcon"},[_c('tooltip',{attrs:{"text":_vm.feedbackMessage}},[_c(VIcon,{attrs:{"color":_vm.iconColor,"right":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }